import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import Login from './pages/login';
import AIMoodSelection from './pages/ai-mood-selection';
import GemCollection from './pages/gem-collection';
import GameArena from './pages/game-arena';
import MainMenu from './pages/main-menu';
import Register from './pages/register';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={
          <ProtectedRoute>
            <MainMenu />
          </ProtectedRoute>
        } />
        <Route path="/main-menu" element={
          <ProtectedRoute>
            <MainMenu />
          </ProtectedRoute>
        } />
        <Route path="/ai-mood-selection" element={
          <ProtectedRoute>
            <AIMoodSelection />
          </ProtectedRoute>
        } />
        <Route path="/gem-collection" element={
          <ProtectedRoute>
            <GemCollection />
          </ProtectedRoute>
        } />
        <Route path="/game-arena" element={
          <ProtectedRoute>
            <GameArena />
          </ProtectedRoute>
        } />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
